<template>
  <!-- 头 -->
  <div class="container">
    <div class="item" style="margin-left: 50px;">
      <img src="/首页/logo_new.png" alt="" style="width: 100px;padding: 20px;" />
    </div>
    <div class="item">
      <a @click.prevent="$router.push({ name: 'home' })"
         class="underline-effect-border header-height"
      >
        <span style="font-weight: normal; font-size: 0.85vw; display: inline-block; line-height: 1.2; letter-spacing: 1px;">
          Homepage<br />
        <span style="font-weight: 550; font-size: 0.9vw;">首页</span>
        </span>
      </a>
    </div>
    <div class="item product-center" style="cursor: pointer">
      <a
        @click.prevent="$router.push({ name: 'stapleFoodGrain' })"
        class="underline-effect-border header-height"
      >
        <span style="font-weight: normal; font-size: 0.85vw; display: inline-block; line-height: 1.2; letter-spacing: 1px;">
          Product center<br />
        <span style="font-weight: 550; font-size: 0.9vw;">产品中心</span>
        </span>
      </a>
      <!-- 下拉菜单 -->
      <div class="dropdown-menu dropdown-menu-div">
        <a @click.prevent="$router.push({ name: 'stapleFoodGrain' })" class="link-text" style="align-items:center;font-size:0.9vw;">主粮系列</a>
        <a @click.prevent="$router.push({ name: 'snackSeries' })" class="link-text" style="margin-top: -8px;align-items:center;font-size:0.9vw">零食系列</a>
        <a @click.prevent="$router.push({ name: 'suppliesSeries' })" class="link-text" style="margin-top: -8px;align-items:center;font-size:0.9vw">用品系列</a>
        <a @click.prevent="$router.push({ name: 'nutritionHealthCare' })" class="link-text" style="margin-top: -8px;font-size:0.9vw">营养品/药品</a>
      </div>

    </div>
    <div class="item about-us" style="">
      <a
        @click.prevent="$router.push({ name: 'about' })"
        class="underline-effect-border header-height"
      >
        <span style="font-weight: normal; font-size: 0.85vw; display: inline-block; line-height: 1.2; letter-spacing: 1px;">
          About us<br />
        <span style="font-weight: 550; font-size: 0.9vw;">关于我们</span>
        </span>
      </a>
    </div>
    <div class="item">
      <a
        @click.prevent="$router.push({ name: 'brandDynamics' })"
        class="underline-effect-border header-height"
      >
        <span style="font-weight: normal; font-size: 0.85vw; display: inline-block; line-height: 1.2; letter-spacing: 1px;">
          Brand Dynamics<br />
        <span style="font-weight: 550; font-size: 0.9vw;">品牌动态</span>
        </span>
      </a>
    </div>

    <div class="item">
      <a
        @click.prevent="$router.push({ name: 'contactUs' })"
        class="underline-effect-border header-height"
      >
        <span style="font-weight: normal; font-size: 0.85vw; display: inline-block; line-height: 1.2; letter-spacing: 1px;">
          Contact us<br />
        <span style="font-weight: 550; font-size: 0.9vw;">联系我们</span>
        </span>
      </a>
    </div>


    <div class="item search">
      <div class="search_item">
        <input
          v-model="searchQuery"
          placeholder="搜索"
          type="text"
          @keyup.enter="performSearch"
          :style="{
        padding: '10px 45px 10px 15px',
        border: '1px solid #ccc',
        borderRadius: '25px',
        outline: 'none',
        fontSize: '16px',
        boxSizing: 'border-box',
        width: '200px',
        height: '32px',
        backgroundColor: '#F1F1F1',
      }"
        />
      </div>
      <div class="search_item" style="margin-left: -40px;">
        <button @click="performSearch" :style="{ marginTop: '3px', border: 'none', backgroundColor: 'transparent' }">
          <!-- SVG图标 -->
          <svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            style="fill: currentColor; margin-left: -10px;"
          >
            <path
              d="M192 448c0-141.152 114.848-256 256-256s256 114.848 256 256-114.848 256-256 256-256-114.848-256-256z m710.624 409.376l-206.88-206.88A318.784 318.784 0 0 0 768 448c0-176.736-143.264-320-320-320S128 271.264 128 448s143.264 320 320 320a318.784 318.784 0 0 0 202.496-72.256l206.88 206.88 45.248-45.248z"
              fill="#8a8a8a"
            ></path>
          </svg>
        </button>
      </div>
      <!-- 搜索结果容器 -->
      <div class="search-results" v-if="showResults">
        <ul style="list-style: none; margin: 0; padding: 0;position: fixed">
          <li
            v-for="(product, index) in displayedProducts"
            :key="index"
            style="margin-left: 0"
          >
            <a
              @click.prevent="$router.push({ name: product.url })"
              style="font-weight: bold; color: #2bd6aa;cursor: pointer;"
              class="no-focus-outline"
            >
              {{ product.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      showResults: false, // 控制搜索结果的显示
      searchQuery: "",
      showDropdown: false,
      page: [
        { name: "动态新闻", url: "brandDynamics" },
        { name: "企业产品", url: "stapleFoodGrain" },
        { name: "联系方式", url: "contactUs" },
        { name: "猫粮", url: "stapleFoodGrain" },
        { name: "狗粮", url: "stapleFoodGrain" },
      ],
      displayedProducts: [], // 用于存储当前显示的产品列表
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    },
  },
  methods: {
    performSearch() {
      this.showResults = true; // 显示搜索结果
      const query = this.searchQuery.toLowerCase().trim();
      if (query) {
        this.displayedProducts = this.page.filter((product) =>
          product.name.toLowerCase().includes(query)
        );
      } else {
        this.displayedProducts = [];
      }
    },
  },
};
</script>

<style scoped>
/* 媒体查询 - PC 通常为 1366px 以上 */
@media (min-width: 1367px) {
  .dropdown-menu-div {
    margin-top: 220px;
    width: 6.8vw;
    height: 15vh;
  }
  .container {
    background-color: white;
    display: flex;
    flex-direction: row; /* 默认值，水平排列 */
    justify-content: space-between; /* 水平间距均匀分布 */
    gap: 10px; /* 项目之间的间距 */
    position: fixed; /* 固定在页面顶部 */
    top: 0;          /* 距离顶部 0px */
    left: 0;         /* 距离左侧 0px */
    width: 100%;     /* 宽度为 100% */
    height: 100px;
    z-index: 9999;
    .item {
      text-align: center;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .header-height{
      display: flex;
      height: 5vh;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      cursor: pointer;
    }
    .search{
      display: flex;
      flex-direction: row; /* 默认值，水平排列 */
      justify-content: space-between; /* 水平间距均匀分布 */
      gap: -1px;
      margin-right:44px;
    }


  }
}
/* 媒体查询 - 笔记本通常为 1366px 以下 */
@media (max-width: 1366px) {
  .dropdown-menu-div {
    margin-top: 180px;
    width: 8.5vw;
    height: 18vh;
  }
  .header-height{
    height: 8vh;
    display: flex;
    text-decoration: none;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .container {
    background-color: white;
    display: flex;
    flex-direction: row; /* 默认值，水平排列 */
    justify-content: space-between; /* 水平间距均匀分布 */
    gap: 10px; /* 项目之间的间距 */
    position: fixed; /* 固定在页面顶部 */
    top: 0;          /* 距离顶部 0px */
    left: 0;         /* 距离左侧 0px */
    width: 100%;     /* 宽度为 100% */
    height: 100px;
    z-index: 9999;
    .item {
      height: 100px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .search{
      display: flex;
      flex-direction: row; /* 默认值，水平排列 */
      justify-content: space-between; /* 水平间距均匀分布 */
      gap: -1px;
      margin-right:44px;
    }


  }
}

.product-center .dropdown-menu {
  display: none;
  opacity: 0;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 99999999;
  position: absolute; /* 使用绝对定位 */
  background-color: #ffffff;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.product-center:hover .dropdown-menu,
.product-center .dropdown-menu:hover {
  display: block;
  opacity: 1;
  visibility: visible;
}

.dropdown-menu a {
  display: block;
  text-decoration: none;
  color: #333;
  white-space: nowrap;
}


/* 外部 CSS 文件或 <style> 标签内的样式 */
.product-link {
  text-decoration: none;
  color: #393939;
  cursor: pointer;
  position: relative;
  display: inline-block;
}

.product-link .link-text {
//transition: color 0.3s ease;
}

.product-link:hover .link-text {
  color: #00d6a9;
}

.product-link::after {
  content: ""; /* 必须设置内容为空字符串 */
  position: absolute;
  width: 0; /* 默认状态下宽度为 0 */
  left: 0;
  height: 2px; /* 下划线高度 */
  background-color: #00d6a9; /* 下划线颜色 */
  transition: width 0.3s ease;
}

.product-link:hover::after {
//border-bottom: 1px solid #00d6a9; /* 添加红色的底部边框 */
//width: 100%; /* 悬停时扩展到 100% 宽度 */
}

/* 外部 CSS 文件或 <style> 标签内的样式 */
.dropdown-menu .link-text {
  display: block;
  text-decoration: none;
  font-size: 16px;
  color: #393939; /* 默认字体颜色 */
  padding: 8px 0; /* 可选：增加一些内边距使点击区域更大 */
  transition: color 0.3s ease; /* 平滑过渡效果 */
}

.dropdown-menu .link-text:hover {
  color: #00d6a9; /* 悬停时字体颜色 */
}


/* 外部 CSS 文件或 <style> 标签内的样式 */
.item.search {
  display: flex;
  align-items: center;
  position: relative;
}

.search_item {
  margin-right: 10px;
}

.search-results {
  position: absolute;
  top: 72%;
  left: 20px;
  right: 0;
  height: 200px;
  text-align: left;
  z-index: 1;
  display: flex;
  flex-direction: column;
}




/* 为 new-class 新建样式 */
.product-link-hover {
  position: relative; /* 相对定位，方便伪元素定位 */
}

.product-link-hover:hover::after {
  content: ""; /* 创建空内容，仅展示直线 */
  position: absolute; /* 绝对定位 */
  bottom: 0; /* 底部对齐 */
  left: 0; /* 左边对齐 */
  width: 100%; /* 宽度为a标签的100% */
  height: 2px; /* 直线的高度 */
  background-color: #00d6a9; /* 直线的颜色 */
  border-radius: 2px; /* 圆角效果 */
}


.underline-effect-border {
  text-decoration: none;
  color: #393939; /* 根据需要调整 */
  cursor: pointer;
  border-bottom: 2px solid transparent; /* 设置透明边框 */
  transition: border-color 0.3s ease-in-out;
}
.underline-effect-border:hover span {
  color: #00d6a9; /* 改变span文字颜色 */
}
.underline-effect-border:hover {
  border-bottom-color: #00d6a9; /* 悬停时改变边框颜色 */
}
</style>
